import { EntityFeatureCategoryType } from "./entity-feature-category-type.model"
import { EntityFeature, EntityFeatureBase } from "./entity-feature.model"
import { EntityInfo, EntityInfoBase } from "./entity-info.model"
import { EntityStateType } from "./entity-state-type.model"
import { EntityType, EntityTypeBase } from "./entity-type.model"


export class EntityBase {

	id!: number
	disabledDate!: Date
	logoUrl!: string
	state!: number
	entityInfoId!: number
	entityInfo!: EntityInfo
	entityTypeId!: number
	entityType!: EntityType
	features: EntityFeature[] = []

	static fromEntity(entity: Entity): EntityBase {
		const current = new EntityBase()
		Object.assign(current, entity)

		current.entityInfo = entity.entityInfo ? EntityInfoBase.fromEntityInfo(entity.entityInfo) : undefined!
		current.entityType = entity.entityType ? EntityTypeBase.from(entity.entityType) : undefined!

		current.features = (entity.features ?? []).map(EntityFeatureBase.fromEntityFeature);
		current.features.sort(EntityFeatureBase.cmp);

		return current;
	}

	stateToText(): string {
		switch (this.state) {
			case EntityStateType.active:
				return 'Actiu'
			case EntityStateType.readonly:
				return 'Lectura'
			case EntityStateType.inactive:
				return 'Inactiu'
			default:
				return 'Desconegut'
		}
	}

	isActive(): boolean {
		return this.state === EntityStateType.active
	}

	isReadOnly(): boolean {
		return this.state === EntityStateType.readonly
	}

	isInactive(): boolean {
		return this.state === EntityStateType.inactive
	}

	findCategory(featureCategory: EntityFeatureCategoryType, defaultValue: string): EntityFeature {
		const existing = this.features.find(f => f.category === featureCategory)
		return existing ?? {
			...new EntityFeatureBase(),
			category: featureCategory,
			entityId: this.id,
			value: defaultValue,
		}
	}

	private hasFeatureEnabled(category: EntityFeatureCategoryType): boolean {
		return this.features.find(f => f.category === category)?.value === 'true'
	}

	hasOU(): boolean {
		return this.hasFeatureEnabled(EntityFeatureCategoryType.ORGANIZATIONAL_UNIT)
	}

	hasSarcat(): boolean {
		return this.hasFeatureEnabled(EntityFeatureCategoryType.SARCAT)
	}

	hasInbox(): boolean {
		return this.hasFeatureEnabled(EntityFeatureCategoryType.INBOX)
	}

	isPromoter(): boolean {
		return this.hasFeatureEnabled(EntityFeatureCategoryType.PROMOTER)
	}

	updateCategory(): void { }
}

export interface Entity extends EntityBase {
	
}
